import React, { useContext } from "react";
import PropTypes, { exact } from "prop-types";
import { Avatar, Card, Heading, Subtitle } from "uikit/components";
import styles from "./SportsmanInfo.module.styl";
import Moment from "moment";
import { getPluralFormOfYear } from "utils";
import { MediaContext } from "app/media/MediaContext";

export default function SportsmanInfo({ sportsman }) {
    const { isDesktop } = useContext(MediaContext);

    let age = null;
    let birthDate = null;
    if (sportsman.birthDate) {
        birthDate = Moment(sportsman.birthDate);
        const year = Moment(new Date()).diff(birthDate, "years");
        age = `${year} ${getPluralFormOfYear(year)}`;
    }

    return (
        <Card borderRadius={"giant"} className={styles.container}>
            <div className={styles.avatarContainer}>
                <Avatar
                    uri={sportsman.avatarUrl}
                    shape={"circle"}
                    size={isDesktop ? "large" : "big"}
                    sex={sportsman.sex}
                />
            </div>
            <div className={styles.info}>
                <div className={styles.name}>
                    <Heading size={isDesktop ? "h2" : "h3"}>
                        {sportsman.lastName} {sportsman.firstName} {sportsman.middleName}
                    </Heading>
                </div>
                <div className={styles.row}>
                    <div className={styles.title}>
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            Вид спорта:
                        </Subtitle>
                    </div>
                    <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                        {sportsman.sportType}
                    </Subtitle>
                </div>
                <div className={styles.row}>
                    <div className={styles.title}>
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>Субъект:</Subtitle>
                    </div>
                    <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                        {sportsman.region}
                    </Subtitle>
                </div>
                <div className={styles.row}>
                    <div className={styles.title}>
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            Организация:
                        </Subtitle>
                    </div>
                    <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                        {sportsman.school}
                    </Subtitle>
                </div>
                <div className={styles.row}>
                    <div className={styles.title}>
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                            Этап подготовки:
                        </Subtitle>
                    </div>
                    <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                        {sportsman.sportTrainingLevel}
                    </Subtitle>
                </div>
                <div className={styles.row}>
                    <div className={styles.title}>
                        <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>Возраст:</Subtitle>
                    </div>
                    <Subtitle size={isDesktop ? "subtitle-2" : "subtitle-3"}>
                        {birthDate && age ? (
                            <>
                                {age} ({birthDate.format("DD.MM.YYYY")} г.р.)
                            </>
                        ) : (
                            "-"
                        )}
                    </Subtitle>
                </div>
            </div>
        </Card>
    );
}

SportsmanInfo.propTypes = {
    sportsman: exact({
        avatarUrl: PropTypes.string,
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        middleName: PropTypes.string.isRequired,
        sportType: PropTypes.string.isRequired,
        region: PropTypes.string.isRequired,
        school: PropTypes.string.isRequired,
        sportTrainingLevel: PropTypes.string.isRequired,
        birthDate: PropTypes.string.isRequired,
        sex: PropTypes.string.isRequired,
    }).isRequired,
};
